import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Icon / nav-arrow-down",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M3 0.5C1.61929 0.5 0.5 1.61929 0.5 3V11C0.5 12.3807 1.61929 13.5 3 13.5H11C12.3807 13.5 13.5 12.3807 13.5 11V3C13.5 1.61929 12.3807 0.5 11 0.5H3Z",
			stroke: "#3F3F3F"
		}), /* @__PURE__ */ _jsx("path", {
			id: "vector",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.73483 5.23508C3.88128 5.08863 4.11872 5.08863 4.26517 5.23508L7 7.96991L9.73484 5.23508C9.88128 5.08863 10.1187 5.08863 10.2652 5.23508C10.4116 5.38153 10.4116 5.61896 10.2652 5.76541L7.26517 8.76541C7.11872 8.91186 6.88128 8.91186 6.73483 8.76541L3.73483 5.76541C3.58839 5.61896 3.58839 5.38153 3.73483 5.23508Z",
			fill: "white"
		})]
	})
});
export default SvgNavArrowDown;
